import {EditableFieldModel} from "@white-label/components/page-builder/models/edit-component.model";
import {FieldType} from "@white-label/components/page-builder/models/model.map";

export class FaqModel {
    questions = new EditableFieldModel('questions', FieldType.array, [
        new OneQuestion(), new OneQuestion(), new OneQuestion(), new OneQuestion()
    ], OneQuestion)
    fieldsMap = [this.questions];

    constructor(data?: {questions?: any}) {
        if(data?.questions){
            this.questions.value = [];
            for(let question of data?.questions.value){
                this.questions.value.push(new OneQuestion(question));
            }
        }
    }
}

export class OneQuestion {
    question = new EditableFieldModel('question', FieldType.text, 'What is your question?');
    answer = new EditableFieldModel('answer', FieldType.text, 'This is the answer!');
    fieldsMap = [this.question, this.answer];
    constructor(data?:{question?: any, answer?: any}) {
        if(data?.question){
            this.question.value = data.question.value;
        }
        if(data?.answer){
            this.answer.value = data.answer.value;
        }
    }
}
